// extracted by mini-css-extract-plugin
export default {"dropdown":"Custom_dropdown__XEBvJ","dropdownMenu":"Custom_dropdownMenu__vxB7Q"};